/* eslint-disable jsx-a11y/iframe-has-title */
// https://github.com/xigua1994/react-tiga-swiper/blob/master/README.zh-cn.md
import React from 'react'
import "./index.css";
import { BsyUtils } from "../../../utils/Utils";
import BsyDashBase from "../BsyDashBase";
import classNames from 'classnames'

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 * 
 */
class BysDashEmbeddedIframe extends BsyDashBase {
    constructor(props) {
        super(props);
        this.state = {
            embeddedIframeModel: props.embeddedIframeModel,
            fullStatus:false,
            iconClass:'icon-bsy-full'
        };
    }

    componentDidMount() {
       //不清楚为啥要加上才能显示带数据图标
       if (this.props.getContext) {
        this.props.getContext(this);
      }
    }
    refreshData(){
        this.setState({
            embeddedIframeModel : ""
        })
        const embeddedIframeModel = this.state.embeddedIframeModel
        setTimeout(()=>{
            this.setState({
                embeddedIframeModel:embeddedIframeModel
            })
        },10)
    }
    openNewPage(){
        window.open(this.state.embeddedIframeModel)
    }
    zoonTransform(){
        // const status = !this.state.fullStatus
        // this.setState({
        //     fullStatus:status
        // })
        // !status?this.setState({
        //     iconClass:'icon-bsy-full'
        // }):this.setState({
        //     iconClass:'icon-bsy-not-full'
        // })
        let full = BsyUtils.applyFunc(this, this.props.onFullScreen, [], !1);
        this.setState({
            iconClass: full ? 'icon-bsy-not-full' : 'icon-bsy-full'
        }) 
    }
    loadData = (n, d) => {
        BsyUtils.applyFunc(this, this.props.onLoadSuccess, [{}, n, d], !1);
    };
    render() {
        return <>
            <div className={classNames('t-embedded-iframe')}>
                <iframe src={this.state.embeddedIframeModel}></iframe>
                <div className='t-controls block-operate'>
                  
                     <i className="icon-bby-reportmenu-15 operate-btn" onMouseEnter={(event) => {
                                            window.FX.UI.showPopover({
                                                position: "bottomLeft",
                                                anchor: window.$(event.target),
                                                content: window.$("<span/>").text(React.language('refresh')),
                                                type: "dark"
                                            })
                                        }} onMouseLeave={() => {
                                            window.FX.UI.closePopover()
                                        }} onClick={()=>{this.refreshData()}}>
                                        </i>
                    <i className="icon-bby-iconfenxiangzhi operate-btn" onMouseEnter={(event) => {
                                            window.FX.UI.showPopover({
                                                position: "bottomLeft",
                                                anchor: window.$(event.target),
                                                content: window.$("<span/>").text(React.language('data.submitPrompt.href.tip1')),
                                                type: "dark"
                                            })
                                        }} onMouseLeave={() => {
                                            window.FX.UI.closePopover()
                                        }} onClick={()=>{this.openNewPage()}}>
                                        </i>
                    <i className={classNames('operate-btn',this.state.iconClass)} onMouseEnter={(event) => {
                                            window.FX.UI.showPopover({
                                                position: "bottomLeft",
                                                anchor: window.$(event.target),
                                                content: this.state.fullStatus?window.$("<span/>").text(React.language('zoomOut')):window.$("<span/>").text(React.language('zoomIn')),
                                                type: "dark"
                                            })
                                        }} onMouseLeave={() => {
                                            window.FX.UI.closePopover()
                                        }} onClick={()=>{this.zoonTransform()}}>
                                        </i>
                </div>
            </div>
        </>;
    }
}

BysDashEmbeddedIframe.propTypes = propTypes;
BysDashEmbeddedIframe.defaultProps = defaultProps;
// #endregion

export default BysDashEmbeddedIframe;